module.exports = __webpack_public_path__ + "static/media/zoom.ddb58e05.svg";